import { defineGameCard } from '../authoring/index.js';
export const BorderlandVeteranCard = defineGameCard({
    id: 'borderland_veteran',
    gameplay: { type: 'UNIT', cost: 4, baseStats: { attack: 5, health: 5 } },
    presentation: {
        name: 'Ветеран пограничья',
        description: 'Обычный боец без дополнительных способностей.',
        glyph: {
            colors: ['#10213A', '#573F35', '#5B554E', '#C09567', '#AB592C'],
            rows: [
                '....................',
                '.......111111.......',
                '......12344331......',
                '.....1323443331.....',
                '.....1223443221.....',
                '.....1232442331.....',
                '.....1311551131.....',
                '.....1245445421.....',
                '.....1344444431.....',
                '.....1345225421.....',
                '.....1255225521.....',
                '..111325555552111...',
                '.122232222222233221.',
                '.1222222222332222221',
                '13333112222221133331',
                '13333331111113333331',
                '12221132333233311221',
                '.111133233323333111.',
                '....1333333333331...',
                '.....11111111111....',
            ],
        },
    },
    role: 'playable',
});
//# sourceMappingURL=borderland_veteran.js.map